import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { AppComponentGenericComponent } from '../../custom/app-component-generic/app-component-generic.component';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'app-gestione-stati',
  templateUrl: './gestione-stati.component.html',
  styleUrls: ['./gestione-stati.component.css']
})
export class GestioneStatiComponent extends AppComponentGenericComponent implements OnInit {
	statiSync: Subscription;
	stati: any[] = [];

	newState: any = {
		nome : '',
		codice : '',
		atto : '',
		bollettino : '',
		rate : ''
	}

	editingState: any = {
		id : '',
		nome : '',
		codice : '',
		atto : '',
		bollettino : '',
		rate : ''
	}

	constructor(protected dataService: DataService) {
		super(dataService, 'gestione-stati');
	}

	ngOnInit() {
		this.statiSync = this.dataService.defaultStates$.subscribe(
			stati => {
				this.stati = stati;
			});
	}

	reset() {
		this.newState.nome = '';
		this.newState.codice = '';
		this.newState.atto = '';
		this.newState.bollettino = '';
		this.newState.rate = '';
	}

	checkBollettinoNew(check: string) {
		switch (check) {
			case 'atto':
				if (!this.newState.atto) {
					this.newState.bollettino = false;
					this.newState.rate = false;
				}
				break;
			case 'bollettino':
				if (this.newState.bollettino) {
					this.newState.atto = true;
				}
				else {
					this.newState.rate = false;
				}
				break;
			case 'rate':
				if (this.newState.rate) {
					this.newState.atto = true;
					this.newState.bollettino = true;
				}
				break;
		}
	}

	checkBollettinoEdit(check: string) {
		switch (check) {
			case 'atto':
				if (!this.editingState.atto) {
					this.editingState.bollettino = false;
					this.editingState.rate = false;
				}
				break;
			case 'bollettino':
				if (this.editingState.bollettino) {
					this.editingState.atto = true;
				}
				else {
					this.editingState.rate = false;
				}
				break;
			case 'rate':
				if (this.editingState.rate) {
					this.editingState.atto = true;
					this.editingState.bollettino = true;
				}
				break;
		}
	}

	saveNewState() {
		if (this.newState.nome != '' && this.newState.codice != '') {
			this.newState.atto = Number(this.newState.atto);
			this.newState.bollettino = Number(this.newState.bollettino);
			this.newState.rate = Number(this.newState.rate);

			this.dataService.insert("stati", this.newState,false,(error,res) => {
				if (error) {
					this.dataService.openMessage('INSERIMENTO STATO','si è verificato un errore');
				}
				if(res){
					this.dataService.openMessage('INSERIMENTO STATO','Stato inserito con successo');
					this.reset();
				}
			});
		}
	}

	editState(state: any) {
		if (state.id != this.editingState.id) {
			this.editingState.id = state.id;
			this.editingState.nome = state.nome;
			this.editingState.codice = state.codice;
			this.editingState.atto = state.atto;
			this.editingState.bollettino = state.bollettino;
			this.editingState.rate = state.rate;
		}
		else {
			this.editingState.id = '';
		}
	}

	deleteState(id: any) {
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: id });

		this.dataService.delete("stati", localFilters, true, (error,res) => {
			if (error) {
				//this.dataService.openMessage('ELIMINAZIONE STATO','si è verificato un errore');
			}
			if(res){
				this.dataService.openMessage('ELIMINAZIONE STATO','Stato eliminato con successo');
				this.reset();
			}
		});
	}

	saveEditedState() {
		console.log('save edited state', this.editingState);
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: this.editingState.id });

		this.editingState.atto = Number(this.editingState.atto);
		this.editingState.bollettino = Number(this.editingState.bollettino);
		this.editingState.rate = Number(this.editingState.rate);

		this.dataService.update("stati", localFilters, this.editingState, false, (error,res) => {
			if(res){
				this.dataService.openMessage('MODIFICA STATO','Stato modificato con successo');
				this.editingState.id = '';
			}
		});
	}

	undoEditingState() {
		console.log('undo');
		this.editingState.id = '';
	}

	ngOnDestroy() {
		this.statiSync.unsubscribe();
	}
}
